module.exports = __webpack_public_path__ + "img/cta-banner-2.94bae736.png";